import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { IApiRiskType } from '../../modules/graphql/types/types';
import { RiskTypesService } from '../../services';
import _ from 'lodash';

@Component({
  selector: 'app-risk-type-multi-select-kendo',
  templateUrl: './risk-type-multi-select-kendo.component.html',
  styleUrls: ['./risk-type-multi-select-kendo.component.scss']
})
export class RiskTypeMultiSelectKendoComponent implements OnInit, OnChanges {

  @Input() placeholder = "Select type";
  @Input() label = "Risk Type";
  @Input() disabled = false;
  @Input() selectedId: Array<string> = [];

  @Output() selectionChanged = new EventEmitter<string[] | null>();
  @Output() enteredPressed = new EventEmitter<Number>();

  public selectedValue = [];
  public riskTypes: IApiRiskType[] = [];

  constructor(
    private riskTypeService: RiskTypesService
  ) {}

  ngOnInit(): void {
    this.riskTypeService.riskTypes().subscribe((types) => this.riskTypes = types);
    if (!this.selectedId || this.selectedId?.length === 0) {
      this.selectedValue = [];
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!_.isEqualWith(this.selectedValue, changes?.selectedId?.currentValue)) {
      this.selectedId = changes?.selectedId?.currentValue || [];
        if (this.selectedId?.length) {
          this.selectedValue = this.selectedId
        } else {
          this.selectedValue = [];
        }
    }
  }

  public searchSelect($event) {
    this.selectedId = $event;
    this.selectionChanged.emit(this.selectedId);
  }

  public tagMapper(tags: any[]): any[] {
    return tags.length < 1 ? tags : [tags];
  }

  public onEnterPress() {
    this.enteredPressed.emit(Math.random());
  }

}
